<template>
      
      <section class="base_featured_product">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <div class="title-wrapper">
                <h4  :contenteditable="edit == 'true' ? 'true' : 'false'" v-on:blur="editText1($event)">{{data.text1}}</h4>
              </div>

            </div>
            <div class="col-12" v-if="edit == 'true'">
                <select class="form-select" v-model="localMode">
                  <option value="0">Ngẫu nhiên</option>
                  <option value="1">Theo danh mục</option>
                  <option value="2">Chọn sản phẩm thủ công</option>
                </select>
            </div>
            <div class="col-12" v-if="edit == 'true'">
                <div class="mb-3" v-if="localMode == 1">
                    <label for="cate-id" class="form-label">ID danh mục</label>
                    <input type="text" class="form-control" id="cate-id" v-model="localCateId">
                </div>
                
                <div class="mb-3" v-if="localMode == 2">
                    <label for="cate-id" class="form-label">Danh sách sản phẩm(id sản phẩm, cách nhau dấu ",")</label>
                    <input type="text" class="form-control" id="cate-id" v-model="localProductList">
                </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div
                class="product-wrapper product_carousel splide is-overflow is-initialized splide--grid splide--slide splide--ltr splide--draggable is-active"
                id="splide01" role="region" aria-roledescription="carousel">
                <div class="splide__track splide__track--slide splide__track--ltr splide__track--draggable"
                  id="splide01-track" aria-live="polite" aria-atomic="true">
                  <div class="splide__list" id="splide01-list" role="presentation">
                    <ProductItem v-for="product in products" :key="product" :id="product" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </section>
</template>
<script>
import ProductItem from "@/components/Home/ProductItem.vue";
export default {
  props: ["edit", "data"],
  computed: {
    navMenu() {
      return this.$store.getters.navData;
    },
    products() {
        if(this.localMode == 1) {
            return this.chauRua;
        } else if(this.localMode == 2) {
            return this.localProductList.split(",").map((item) => item.trim()).filter((item) => item !== "");
        }
        return this.randomProducts;
    },
    randomProducts() {
      return this.$store.getters.randomProducts;
    },
    chauRua() {
      return this.$store.getters.productsByCate(this.localCateId);
    },
    localCateId: {
      get() {
        return this.data.cate_id;
      },
      set(val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.data.cate_id = val;
      }
    },
    localMode: {
      get() {
        return this.data.mode;
      },
      set(val) {
        console.log(val);
        // eslint-disable-next-line vue/no-mutating-props
        this.data.mode = val;
      }
    },
    localProductList: {
      get() {
        return this.data.product_list;
      },
      set(val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.data.product_list = val;
      }
    }
  },
  methods: {
    editText1(event) {
      let t = this;
      t.data.text1 = event.target.innerText;
    },
    cateLink(cateObj) {
      return "/danh-muc/" + this.removeVietnameseTones(cateObj.name).replaceAll(" ", "-").toLowerCase() + "/" + cateObj._id;
    },
    resizeImage(link, width, height) {
        const test = /^\/images\/(.+)\.(jpg|png|webp)$/.exec(link);
        if(test) {
            // Đổi link ban đầu thành link đã được resize (ví dụ sử dụng một service resize)
            return "/images-thumb/" + test[1] + "." + test[2] + "." + width + "." + height + "." + test[2];
        } else {
            return link;
        }
    },
    removeVietnameseTones(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      return str;
    },
  },
  components: {
    ProductItem,
  },
};
</script>
<style lang="less">
.home-popular-categories {
  padding-top: 40px;

  .section-title {
    font-size: 24px;
    line-height: 1.4;
    font-weight: 700;
    text-align: left;
    padding-bottom: 20px;
  }

  .stickyscroll {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: thin;
    overflow-y: hidden;
    gap: 20px;

    .scroll-item {
      width: 100px;

      .image {
        border-radius: 50%;
        width: 100px;
        height: 100px;
        overflow: hidden;

        img {
          width: 100%;
        }
      }

      a {
        color: inherit;
        text-decoration: none;
      }

      .title-content {
        padding-top: 15px;

        .title {
          line-height: 1.4;
          font-weight: 700;
          font-size: 16px;
        }

        .cat-button {
          font-size: 14px;
        }
      }
    }
  }
}


@media (min-width: 992px) {
  
  .home-popular-categories {
    .stickyscroll {
      .scroll-item {
        width: 140px;

        .image {
          border-radius: 50%;
          width: 140px;
          height: 140px;
          overflow: hidden;

          img {
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>